import { render, staticRenderFns } from "./DashboardSummary.vue?vue&type=template&id=cc2ff96a&scoped=true"
import script from "./DashboardSummary.vue?vue&type=script&lang=js"
export * from "./DashboardSummary.vue?vue&type=script&lang=js"
import style0 from "./DashboardSummary.vue?vue&type=style&index=0&id=cc2ff96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2ff96a",
  null
  
)

export default component.exports